var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import NavigationMenu from "./menu/NavigationMenu";
import { Start, FirstPage } from "@mui/icons-material";
import MapMenu from "./menu/MapMenu";
import LoginMenu from "./menu/LoginMenu";
import LoginModal from "./LoginModal";
import { logout } from "../utils/auth/identity";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
//identity
import { refreshToken, getTokenExpiry } from "../utils/auth/identity";
import "../styles/global.css";
import AdminMenu from "./menu/AdminMenu";
const drawerWidth = 220;
const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});
const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
});
const DrawerHeader = styled("div")(({ theme }) => (Object.assign(Object.assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar), { minHeight: 70, height: 70 })));
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(["width", "margin"], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));
const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    variants: [
        {
            props: ({ open }) => open,
            style: Object.assign(Object.assign({}, openedMixin(theme)), { "& .MuiDrawer-paper": openedMixin(theme) }),
        },
        {
            props: ({ open }) => !open,
            style: Object.assign(Object.assign({}, closedMixin(theme)), { "& .MuiDrawer-paper": closedMixin(theme) }),
        },
    ],
}));
const ptnLogo = "/img/ptn-logo.png";
const MiniDrawer = ({ children }) => {
    const [open, setOpen] = React.useState(true);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loggedInUserName, setLoggedInUserName] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isUserActive, setIsUserActive] = useState(false);
    const [lastActivityTime, setLastActivityTime] = useState(Date.now());
    const navigate = useNavigate();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
    useEffect(() => {
        if (isMobile) {
            setOpen(false);
        }
    }, [isMobile]);
    //============================================================================================================
    //                          USER ACTIVITY CHECKS
    //============================================================================================================
    useEffect(() => {
        const handleUserActivity = () => {
            setLastActivityTime(Date.now());
            setIsUserActive(true);
        };
        const checkUserActivity = () => {
            if (Date.now() - lastActivityTime > 600000) {
                setIsUserActive(false);
                //console.log("User is no longer active");
            }
            else {
                //get the expiry of the user token and if will expire within then next 60 seconds, refresh the token
                const token = localStorage.getItem("token");
                if (token === null) {
                    return;
                }
                const expiry = getTokenExpiry(token);
                if (expiry && (expiry - Date.now() < 60000)) {
                    //console.log("Token will expire in the next 60 seconds, refreshing token");
                    refreshUserToken();
                }
            }
        };
        const refreshUserToken = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            console.log("Refreshing Token");
            if (localStorage.getItem("token") === null) {
                return;
            }
            if (isUserActive) {
                // Call identity service to refresh token
                try {
                    const newToken = yield refreshToken();
                    if (newToken) {
                        localStorage.setItem("token", newToken);
                        //add the getTokenExpiry number of seconds to the current time to get the expiry time
                        let expiry = (_a = getTokenExpiry(newToken)) !== null && _a !== void 0 ? _a : 0;
                        console.log("Token refreshed and now expires at", new Date(expiry));
                    }
                }
                catch (e) {
                    console.log("Error refreshing token", e);
                }
            }
        });
        // Add event listeners for user activity
        window.addEventListener("mousemove", handleUserActivity);
        window.addEventListener("mousedown", handleUserActivity);
        // Check user activity every 60 seconds
        const activityCheckInterval = setInterval(checkUserActivity, 10000);
        // Cleanup event listeners and intervals on component unmount
        return () => {
            window.removeEventListener("mousemove", handleUserActivity);
            window.removeEventListener("mousedown", handleUserActivity);
            clearInterval(activityCheckInterval);
        };
    }, [isUserActive, lastActivityTime]);
    //============================================================================================================
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawOnChange = () => {
        setOpen(!open);
    };
    //============================================================================================================
    // PAGE LOAD EVENTS, Check if there is a token and user claims in local storage and set the state accordingly
    //============================================================================================================
    useEffect(() => {
        var _a, _b;
        const token = localStorage.getItem("token");
        const userClaims = localStorage.getItem("UserClaims");
        if (token && userClaims) {
            const claims = JSON.parse(userClaims);
            if (claims.length === 0) {
                return;
            }
            const userName = ((_a = claims.find((claim) => claim.type === "UserName")) === null || _a === void 0 ? void 0 : _a.value) || "";
            const userIsAdmin = ((_b = claims.find((claim) => claim.type === "Role")) === null || _b === void 0 ? void 0 : _b.value) ===
                "Site Administrator";
            if (userName && userName.length > 0) {
                setLoggedInUserName(userName);
                setIsLoggedIn(true);
                setIsAdmin(userIsAdmin || false);
            }
        }
    }, []);
    //============================================================================================================
    //                                    LOGIN MENU & MODAL
    //============================================================================================================
    const handleLogInClicked = () => {
        setIsModalOpen(true);
    };
    const handleLogOutClicked = () => {
        logout();
        setIsLoggedIn(false);
        setIsAdmin(false);
        setLoggedInUserName("");
        navigate("/");
    };
    // Modal login success
    const handleLoginSuccess = (userCredential) => {
        var _a, _b;
        localStorage.setItem("token", userCredential.token);
        localStorage.setItem("UserClaims", JSON.stringify(userCredential.userClaims));
        setIsModalOpen(false);
        setLoggedInUserName(((_a = userCredential.userClaims.find((claim) => claim.type === "UserName")) === null || _a === void 0 ? void 0 : _a.value) || "");
        setIsLoggedIn(true);
        setIsAdmin(((_b = userCredential.userClaims.find((claim) => claim.type === "Role")) === null || _b === void 0 ? void 0 : _b.value) === "Site Administrator" || false);
        navigate("/admin/dashboard");
    };
    // Modal login failure
    const handleLoginFailure = (errorMessage) => {
        console.log("Login failed 1", errorMessage);
        setIsLoggedIn(false);
        setIsAdmin(false);
        setLoggedInUserName("");
        localStorage.removeItem("token");
        localStorage.removeItem("UserClaims");
        setIsModalOpen(false);
    };
    const handleOnModalClose = () => {
        setIsModalOpen(false);
    };
    return (React.createElement(Box, { sx: { display: "flex", height: '100%' } },
        React.createElement(CssBaseline, null),
        React.createElement(Box, { position: "fixed", sx: { zIndex: 1302 } },
            React.createElement(Box, { sx: {
                    //display on the far right 10px outside the edge of the drawer
                    position: "absolute",
                    left: open ? `${drawerWidth - 20}px` : "45px",
                    top: "10px",
                    color: "#666666",
                    // circle affect for the box with white background with transparent color
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    borderRadius: "50%",
                    padding: "10px 10px 5px 10px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.9)",
                    // cursor is a pointer on hover
                    cursor: "pointer",
                    zIndex: 1303,
                }, onClick: handleDrawOnChange }, open ? React.createElement(FirstPage, null) : React.createElement(Start, null))),
        React.createElement(AppBar, { position: "fixed", open: open, sx: { zIndex: 1200 } },
            React.createElement(Toolbar, { className: "app-toolbar", sx: { zIndex: 1250 } },
                React.createElement(IconButton, { color: "inherit", "aria-label": "open drawer", onClick: handleDrawerOpen, edge: "start", sx: [
                        {
                            marginRight: 5,
                            display: isMobile ? "none" : "block",
                        },
                        open && { display: "none" },
                    ] },
                    React.createElement(MenuIcon, null)),
                !open ? (React.createElement("img", { src: ptnLogo, id: "mobile-ptn-image", className: "ptn-image-style", alt: "PTN Logo" })) : null,
                React.createElement(Typography, { variant: "h4", noWrap: true, sx: {
                        textAlign: "center",
                        flexGrow: 1,
                        display: isMobile ? "none" : "block",
                    }, component: "div" }, "Pasture Trials Network"),
                React.createElement(Box, { sx: { flexGrow: 1 } }),
                React.createElement(Box, { sx: { display: isMobile ? "none" : "flex", justifyContent: "flex-end" } },
                    React.createElement(LoginMenu, { isLoggedIn: isLoggedIn, loggedInUserName: loggedInUserName, onLoginClicked: handleLogInClicked, onLogoutClicked: handleLogOutClicked })))),
        React.createElement(Drawer, { variant: "permanent", open: open, sx: {
                zIndex: 1300,
            } },
            React.createElement(DrawerHeader, { sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ffffff",
                    padding: "5px 0px 10px 45px",
                    height: "70px",
                    minHeight: "70px !important",
                    boxShadow: "0 4px 6px rgba(100, 100, 100, 0.6)",
                    zIndex: 1301,
                } }, open ? (React.createElement("img", { src: ptnLogo, id: "desktop-ptn-image", className: "ptn-image-style", alt: "PTN Logo" })) : null),
            !isAdmin ? React.createElement(Divider, null) : null,
            React.createElement(NavigationMenu, { toolbarColor: "#ffffff", open: open }),
            !isAdmin ? React.createElement(Divider, null) : null,
            React.createElement(Divider, null),
            !isAdmin ? React.createElement(MapMenu, { toolbarColor: "#ffffff", open: open }) : null,
            isAdmin ? (React.createElement(AdminMenu, { toolbarColor: "#ffffff", isAdmin: isAdmin, open: open })) : null),
        React.createElement(Box, { component: "main", sx: theme => ({
                flexGrow: 1,
                // padding: "15px 5px 5px 0px",
                // allow the content to scroll without breaking the side bar and header
                overflow: "auto",
                width: `calc(100vw - ${theme.spacing(7)} - 1px)`,
                [theme.breakpoints.up("sm")]: {
                    width: `calc(100vw - ${theme.spacing(8)} - 1px)`,
                },
                display: "flex",
                flexDirection: "column",
            }) },
            React.createElement(DrawerHeader, null),
            children,
            React.createElement(LoginModal, { onLoginSuccess: handleLoginSuccess, onLoginFailure: handleLoginFailure, onModalClose: handleOnModalClose, isOpen: isModalOpen }))));
};
export default MiniDrawer;
